import request from '@/util/http';

export default {
  labelList,          //标签列表
  addLabel,           //添加标签
  addUserLabel,       //添加用户标签
  getUserLabel,       //获取这个用户在这家公司的标签
  delUserLabel,       //删除用户标签
}

function labelList(data) {
  return request({
    url: "sys/api/getcompanylablelist",
    method: 'post',
    data
  })
}

function addLabel(data) {
  return request({
    url: "sys/api/addorupdatelable",
    method: 'post',
    data
  })
}

function addUserLabel(data) {
  return request({
    url: "sys/api/touserlable",
    method: 'post',
    data
  })
}

function getUserLabel(data) {
  return request({
    url: "sys/api/getusercompanylablelist",
    method: 'post',
    data
  })
}

function delUserLabel(data) {
  return request({
    url: "sys/api/deluserlable",
    method: 'post',
    data
  })
}